import {
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut,
  apiCollectionbill,
  apiResourcebill,
} from './index';
export default {
  login: opts => {
    return apiResource ({url: '/login', data: opts});
  },
  // 获取通知单列表
  getNotificationList: opts => {
    return apiCollection ({url: '/back/notification', params: {...opts}});
  },
  // 显示通知单细节
  getNotificationDetail: opts => {
    return apiCollection ({
      url: '/back/notification/details',
      params: {...opts},
    });
  },
  // 添加通知单
  addNotification: opts => {
    return apiResource ({url: '/back/notification', data: opts});
  },
  // 修改通知单
  editNotification: opts => {
    return apiPut ({url: '/back/notification/details', data: opts});
  },
  // 删除通知单
  deleteNotification: opts => {
    return apiDelete ({url: '/back/notification', data: opts});
  },
  // 显示预录通知单细节
  getPreNoticeDetail: opts => {
    return apiCollection ({
      url: '/back/pre/notification/details',
      params: {...opts},
    });
  },
  // 修改预录通知单细节
  editPreNotification: opts => {
    return apiPut ({url: '/back/pre/notification', data: opts});
  },
  // 查询产品列表
  getProList: opts => {
    return apiCollection ({url: '/back/product/listModel', params: {...opts}});
  },
  // 查询封装数据
  getPackageList: opts => {
    return apiCollection ({url: '/back/product/listInfo', params: {...opts}});
  },
  // 查询代理商列表
  getAgent: opts => {
    return apiCollection ({url: '/back/agent/listAgent', params: {...opts}});
  },
  // 关键字查询地址
  keywordsgetList: opts => {
    return apiCollection ({url: '/back/agent/listAddr', params: {...opts}});
  },
  // 获取代理商地址
  getAddress: opts => {
    return apiCollection ({url: '/back/agent', params: {...opts}});
  },
  // 添加代理商地址
  addAddress: opts => {
    return apiResource ({url: '/back/agent', data: opts});
  },
  // 更新代理商地址
  editAddress: opts => {
    return apiPut ({url: '/back/agent', data: opts});
  },
  // 删除代理商地址
  deleteAddress: opts => {
    return apiDelete ({url: '/back/agent', data: opts});
  },
  // 显示短信模板信息
  getMessage: opts => {
    return apiCollection ({url: '/back/template', params: {...opts}});
  },
  // 添加短信模板信息
  addMessage: opts => {
    return apiResource ({url: '/back/template', data: opts});
  },
  // 更新短信模板信息
  editMessage: opts => {
    return apiPut ({url: '/back/template', data: opts});
  },
  // 删除短信模板信息
  deleteMessage: opts => {
    return apiDelete ({url: '/back/template', data: opts});
  },
  // 发送短信
  sendMessage: opts => {
    return apiResource ({url: '/back/sms/sendSms', data: opts});
  },
  // 获取客户以及单号
  getClientList: opts => {
    return apiResourcebill ({url: '/get_delivery', data: opts});
  },
  // 获取出货单
  getBillInfo: opts => {
    return apiResourcebill ({url: '/delivery_info', data: opts});
  },
  exportExcel: id => {
    return apiCollectionbill ({url: `/delivery_excel/${id}`});
  },
};



// WEBPACK FOOTER //
// ./src/api/api.js